import React, { useCallback, useEffect, useState } from 'react';
import { getNewsContext } from '../api/newsContext';
import './NewsContextCard.css';

function formatDate(value) {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleString('pt-BR', {
    timeZone: 'America/Sao_Paulo',
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export default function NewsContextCard({
  ticker,
  eventType = 'detalhe do ativo',
  autoLoad = true,
  compact = false,
}) {
  const [state, setState] = useState({ status: autoLoad ? 'loading' : 'idle', data: null, error: null });

  const load = useCallback(async () => {
    if (!ticker) return;
    setState({ status: 'loading', data: null, error: null });
    try {
      const data = await getNewsContext(ticker, eventType);
      setState({ status: 'ready', data, error: null });
    } catch (error) {
      setState({
        status: 'error',
        data: null,
        error: error?.response?.data?.message || 'Contexto indisponível no momento.',
      });
    }
  }, [eventType, ticker]);

  useEffect(() => {
    setState({ status: autoLoad ? 'loading' : 'idle', data: null, error: null });
    if (autoLoad) load();
  }, [autoLoad, load]);

  if (!ticker) return null;
  if (state.status === 'idle') {
    return (
      <button type="button" className="nc-investigate" onClick={load}>
        📰 Investigue a causa
      </button>
    );
  }

  return (
    <section className={`nc-card ${compact ? 'compact' : ''}`} aria-live="polite">
      <div className="nc-head">
        <div>
          <strong>📰 Contexto de notícias</strong>
          <span>Últimos 5 dias · Google News</span>
        </div>
        <span className="nc-disclaimer">gerado por IA · informativo · não é recomendação</span>
      </div>
      {state.status === 'loading' && <div className="nc-loading">Buscando manchetes e contexto…</div>}
      {state.status === 'error' && (
        <div className="nc-error">
          {state.error}
          <button type="button" onClick={load}>Tentar novamente</button>
        </div>
      )}
      {state.status === 'ready' && (
        <>
          <p className="nc-context">{state.data.context}</p>
          {state.data.generatedAt && <div className="nc-time">Atualizado em {formatDate(state.data.generatedAt)}</div>}
          {state.data.headlines?.length > 0 && (
            <ul className="nc-links">
              {state.data.headlines.map((item, index) => (
                <li key={`${item.link}-${index}`}>
                  <a href={item.link} target="_blank" rel="noreferrer">
                    {item.title}
                  </a>
                  <span>{item.source || 'Fonte não identificada'}</span>
                </li>
              ))}
            </ul>
          )}
        </>
      )}
    </section>
  );
}